<template>
  <div>
    <button
      @click="clearCard"
      class="close-card button --bare +pd-none +pd-top-xxs +pd-bottom-xxs"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 320 512"
        class="svg-card-close"
      >
        <path
          fill="currentColor"
          d="M193.94 256L296.5 153.44l21.15-21.15c3.12-3.12 3.12-8.19 0-11.31l-22.63-22.63c-3.12-3.12-8.19-3.12-11.31 0L160 222.06 36.29 98.34c-3.12-3.12-8.19-3.12-11.31 0L2.34 120.97c-3.12 3.12-3.12 8.19 0 11.31L126.06 256 2.34 379.71c-3.12 3.12-3.12 8.19 0 11.31l22.63 22.63c3.12 3.12 8.19 3.12 11.31 0L160 289.94 262.56 392.5l21.15 21.15c3.12 3.12 8.19 3.12 11.31 0l22.63-22.63c3.12-3.12 3.12-8.19 0-11.31L193.94 256z"
          class=""
        ></path>
      </svg>
    </button>
  </div>
</template>

<script>
import tagularModule from 'js/store/helpers/tagular'
export default {
  props: {
    slug: {
      type: String
    }
  },
  methods: {
    clearCard() {
      this.$store.dispatch('removeCard', { slug: this.slug })
      window.location = this.$store.getters.compareUrl

      tagularModule.elementClicked({
        location: 'Compare',
        position: 'Footer',
        elementType: 'Button',
        text: 'X',
        htmlId: ''
      })
    }
  }
}
</script>

<!-- eslint-disable -->
<style lang="scss" scoped>
@import './../../../../sass/brcom/settings/_settings.theme-colors.scss';

.close-card {
  height: 36px;
  width: 36px;
}
.close-card svg {
  width: 22px;
  height: 22px;
  color: $theme-gray-dark;
}
</style>
<!-- eslint-enable -->
